import React from 'react'
import { Inbox, NovuProvider, ReactInboxAppearance } from '@novu/react'
import { useSelector } from 'react-redux'
import { currentUserIdSelector } from '../../redux/session/currentUser/selectors'
import { useAuthority } from '../../utils/Authorizable/authorize'
import useNovuQueryInvalidation from './useNovuQueryInvalidation'
import useNovuNotificationPopup from './useNovuNotificationPopup'
import useNotificationHash from './useNotificationHash'
import useNovuLocalization from './useNovuLocalization'

const appearance: ReactInboxAppearance = {
  elements: {
    preferences__button: { display: 'none' },
    bellContainer: {
      background: 'transparent',
      border: 'none',
      boxShadow: 'none',
      padding: 0,
      margin: 0,
      width: 'auto',
      height: 'auto',
      minWidth: 0,
      minHeight: 0,
      display: 'inline-flex'
    },
    popoverTrigger: {
      padding: 0,
      background: 'transparent',
      border: 'none',
      boxShadow: 'none',
      width: 'auto',
      height: 'auto',
      minWidth: 0,
      minHeight: 0,
      display: 'inline-flex',
      verticalAlign: 'middle'
    },
    bellIcon: {
      color: 'rgba(0, 0, 0, 0.55)',
      width: '15px',
      height: '15px'
    }
  }
}

const NovuInboxContent: React.FC = () => {
  useNovuQueryInvalidation()
  useNovuNotificationPopup()
  const localization = useNovuLocalization()

  return <Inbox appearance={appearance} localization={localization} />
}

const NovuInbox: React.FC = () => {
  const userId = useSelector(currentUserIdSelector)
  const { data: hashData } = useNotificationHash(!!userId, userId)

  if (!userId || !hashData?.hash || !process.env.REACT_APP_NOVU_APP_ID) return null

  return (
    <NovuProvider
      applicationIdentifier={process.env.REACT_APP_NOVU_APP_ID}
      subscriberHash={hashData.hash}
      subscriberId={String(userId)}
    >
      <NovuInboxContent />
    </NovuProvider>
  )
}

export default NovuInbox
